// extracted by mini-css-extract-plugin
module.exports = {"copyButton":"copyButton__2KFtt","copyButtonSmall":"copyButtonSmall__y24KF"};